module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkAQAAAABYmaj5AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAd2KE6QAAAAHdElNRQfdCggPCBrTl6FQAAAAS0lEQVQ4y83UyQkAIAxE0Q8WYEm2bkkWEBg3BDvI5DDwboEs6KtBsjqvWr6qRNMOA8VqSoGDKDphIe4KWeh0Bg7aE6OGhYxu2ufXTR0xya1oJKsNAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE4LTA4LTEzVDE1OjI2OjQzKzA5OjAweQ3b9QAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxMy0xMC0wOFQwNjowODoyNiswOTowMMvnDN4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/tag/36h11/tag36_11_00382_100x100.png
// module id = kSkR
// module chunks = 0